import script from "./FeedBack.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedBack.vue?vue&type=script&setup=true&lang=ts"

import "./FeedBack.vue?vue&type=style&index=0&id=2994162d&lang=scss"
import "./FeedBack.vue?vue&type=style&index=1&id=2994162d&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2994162d"]])

export default __exports__